import React from 'react';
import type { VersionDetailSpa as LazyVersionDetailType } from '@atlassian/jira-spa-apps-software-releases-version-detail/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyVersionDetail = lazyForPaint<typeof LazyVersionDetailType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-software-version-detail", jiraSpaEntry: "async-jira-software-version-detail" */ '@atlassian/jira-spa-apps-software-releases-version-detail'
		),
	),
);

export const VersionDetailPage = (): React.JSX.Element => (
	<LazyPage Page={LazyVersionDetail} pageId="version-detail" shouldShowSpinner={false} />
);
